import {
    HttpClient,
    HttpParams,
    HttpHeaders,
    HttpResponse
} from '@angular/common/http';
import {
    Injectable
} from '@angular/core';
import {
    ApperyioHelperService
} from '../apperyio/apperyio_helper';
import {
    timeout
} from 'rxjs/operators';

/*
  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
import {
    SERVICE
} from './NeurConstants';
import {
    ExportedClass as NeurService
} from './NeurService';

import {
    ExportedClass as PlaceService
} from './PlaceService';

@Injectable()
class NeurBackendService {
    private RequestHeaders: HttpHeaders = new HttpHeaders({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    });
    //private BackendServerDomain: string = 'https://data.mongodb-api.com/app/data-bjwti/endpoint/';
    private BackendServerDomain: string = 'https://api.neurme.net:82/';
    private RequestOptions = {
        headers: this.RequestHeaders,
        params: {},
        body: {},
    }


    constructor(private Apperyio: ApperyioHelperService, private httpClient: HttpClient, private neurService: NeurService, private placeService: PlaceService) {

    }

    private handleError(error: Response | any) {
        let errMsg: string;

        if (error instanceof Response) {
            errMsg = `${error.status} - ${error.statusText}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.log(errMsg)
        return errMsg;
    }

    private async getResponse(reqUrl, reqOpt, reqMethod, timeoutMultiples ? ) {
        if (!timeoutMultiples) timeoutMultiples = 1;
/*
        let time_out = new Promise((resolve, reject) => {
            setTimeout(() => reject(new Error("timeout")), timeoutMultiples * SERVICE.TIMEOUT);
        });
*/
        let data;

        try {
            if (reqMethod == 'post') {
                data = await this.httpClient.post(reqUrl, reqOpt).pipe(timeout(timeoutMultiples * SERVICE.TIMEOUT)).toPromise();
                console.log("received data: ", data);
                //          data = await Promise.race([this.httpClient.post(reqUrl, reqOpt).toPromise(),  time_out]).catch((error) => {  this.handleError(error); return null;});
            } else if (reqMethod == 'get') {
                data = await this.httpClient.get(reqUrl, reqOpt).pipe(timeout(timeoutMultiples * SERVICE.TIMEOUT)).toPromise();
                //          data = await Promise.race([this.httpClient.get(reqUrl, reqOpt).pipe(timeout(100)).toPromise(),  time_out]).catch((error) => {  this.handleError(error); return null;});
            }
        } catch (error) {
            console.log("too bad, error received", error);
            this.handleError(error);
            data = null;
        }
        /**/
                console.log("response data "+JSON.stringify(data))
        /**/
        return data;
    }


    public async login(user_id: string, password: string) {
        const reqUrl = this.BackendServerDomain + "account/login";
        const reqOpt = {
            ...this.RequestOptions,
            'username': user_id,
            'password': password,
        };

        const data = await this.getResponse(reqUrl, reqOpt, 'post', 1);
        return JSON.parse(JSON.stringify(data));
    }

    public async helpLogin(_helpUsername: boolean, verification_id: String) {
        _helpUsername = true;
        const reqUrl = this.BackendServerDomain + "account/verifyAccount";
        const reqOpt = {
            ...this.RequestOptions,
            'verification_id': verification_id,
            'help_username': _helpUsername,
        };

        const data = await this.getResponse(reqUrl, reqOpt, 'post', 1);
        return JSON.parse(JSON.stringify(data));
    }

    public async resetPassword(verification_id: String, verification_code: String, new_password: String) {
        const reqUrl = this.BackendServerDomain + "account/resetPassword";
        const reqOpt = {
            ...this.RequestOptions,
            'verification_id': verification_id,
            'verification_code': verification_code,
            'new_password': new_password
        };
        const data = await this.getResponse(reqUrl, reqOpt, 'post', 1);
        return JSON.parse(JSON.stringify(data));
    }

    public async activateAccount(account_id: String, password: String, phone: String, verification_code: String) {
        const reqUrl = this.BackendServerDomain + "account/activateAccount";
        const reqOpt = {
            ...this.RequestOptions,
            'email': account_id,
            'password': password,
            'phone': phone,
            'code': verification_code
        };

        const data = await this.getResponse(reqUrl, reqOpt, 'post', 1);
        return JSON.parse(JSON.stringify(data)).activate_account;
    }

    public async createAccount(account_id: String, password: String, phone: String) {
        const reqUrl = this.BackendServerDomain + "account/signup";

        const reqOpt = {
            ...this.RequestOptions,
            'email': account_id,
            'password': password,
            'phone': phone
        };

        const data = await this.getResponse(reqUrl, reqOpt, 'post', 1);
        return JSON.parse(JSON.stringify(data));
    }

    public async getAllPlacesName(language: string) {
        const reqUrl = this.BackendServerDomain + "poi/getAllPlacesName";
        let reqOpt = this.RequestOptions;
        reqOpt.params = {
            "language": language
        };

        /**        
                console.log("Getting all places in "+language)      
        /**/

        const data = await this.getResponse(reqUrl, reqOpt, 'get', 5);;

        return JSON.parse(JSON.stringify(data));

    }

    public async getAllCountriesName(language: string) {
        const reqUrl = this.BackendServerDomain + "poi/getAllPlacesName";

        let reqOpt = this.RequestOptions;
        reqOpt.params = {
            "language": language,
            "filter": 'country'
        };
        /**
                console.log("countries "+JSON.stringify(data))
        /**/
        const data = await this.getResponse(reqUrl, reqOpt, 'get', 5);;


        return JSON.parse(JSON.stringify(data));

    }

    public async getVersionNumber(versiontype: string) {
        const reqUrl = this.BackendServerDomain + "appcore/getVersionNumber";

        let reqOpt = this.RequestOptions;
        reqOpt.params = {
            "versiontype": versiontype
        };

        const data = await this.getResponse(reqUrl, reqOpt, 'get', 1);
        /**        
                console.log("versions "+JSON.stringify(data))      
        /**/
        let version_number = 0;
        if (data) {
            version_number = parseInt(data);
        }
        return version_number;
    }

    public async getPlacesInfo(language: string, info_criteria: string[], search_criteria: any) {
        let reqUrl;
        if (search_criteria.hasOwnProperty("bottomup_scope")) {
            reqUrl = this.BackendServerDomain + "poi/nearby";
        } else {
            reqUrl = this.BackendServerDomain + "poi/search";
        }
        let reqOpt = this.RequestOptions;
        reqOpt.params = {
            "language": language,
            "info_criteria": JSON.stringify(info_criteria),
            "search_criteria": JSON.stringify(search_criteria)
        };
        /**/
        console.log("request places info " + JSON.stringify(search_criteria))
        /**/
        const data = await this.getResponse(reqUrl, reqOpt, 'get', 5);;


        let placesInfoList = null;
        if (data != undefined && data !=null) {
            placesInfoList = JSON.parse(JSON.stringify(data));
            for (let i = 0; i < placesInfoList.length; i++) {
                placesInfoList[i] = this.neurService.calibratePlaceImages(placesInfoList[i]);
                placesInfoList[i] = this.placeService.makeMarkers(placesInfoList[i]);
            }
        }
        return placesInfoList;
    }

    public async getPlaceInfo(language: string, cluster_id: Number, info_criteria: string[], search_criteria: any) {
        const reqUrl = this.BackendServerDomain + "poi/clusterSearch";
        let reqOpt = this.RequestOptions;
        reqOpt.params = {
            "language": language,
            "cluster_id": cluster_id.toString(),
            "info_criteria": JSON.stringify(info_criteria),
            "search_criteria": JSON.stringify(search_criteria)
        };

        const data = await this.getResponse(reqUrl, reqOpt, 'get', 5);;
        /**        
                console.log("place info "+JSON.stringify(data))      
        **/
        let placeInfo = null;
        if (data != undefined && data != null) {
            placeInfo = JSON.parse(JSON.stringify(data));
            placeInfo = this.neurService.calibratePlaceImages(placeInfo);
            placeInfo = this.placeService.makeMarkers(placeInfo);
        }
        //console.log("done in getplaceinfo");
        return placeInfo;
    }

    public async createNeurTrip(uid: Number, language: string, selectedPlace: any, info_criteria: string[], search_criteria: any, selected_poi_list: any) {
        const reqUrl = this.BackendServerDomain + "trip/plan"; //this.BackendServerDomain + "CreateNeurTrip";
        let reqOpt = this.RequestOptions;
        reqOpt.params = {
            "userid": uid.toString(),
            "language": language,
            "placeSelected": JSON.stringify(selectedPlace),
            "info_criteria": JSON.stringify(info_criteria),
            "search_criteria": JSON.stringify(search_criteria),
            "selected_poi_list": JSON.stringify(selected_poi_list)
        };

        /**/
        console.log("creating trip...")
        /**/
        const data = await this.getResponse(reqUrl, reqOpt, 'get', 5);;
        /**/
        console.log("place info " + JSON.stringify(data))
        /**/
        return JSON.parse(JSON.stringify(data));
    }

    public async getTrips(account_id: String) {
        const reqUrl = this.BackendServerDomain + "trip/getNeurTrips";

        const reqOpt = this.RequestOptions;
        reqOpt.params = {
            "uid": account_id
        };

        const data = await this.getResponse(reqUrl, reqOpt, 'post', 3);

        return JSON.parse(JSON.stringify(data));

    }
}

/*
    Service class should be exported as ExportedClass
*/
export {
    NeurBackendService as ExportedClass
};